import './spinner.css';

export class Spinner {
    static show() {
        document.getElementsByClassName("presentation")[0].style.display = 'none';
        document.getElementById("spinners").style.display = "flex";
    }

    static hide() {
        document.getElementsByClassName("presentation")[0].style.display = 'flex';
        document.getElementById("spinners").style.display = "none";
    }
}
